import { render, staticRenderFns } from "./ManualTinderScanCreate.vue?vue&type=template&id=f2c25c4e&scoped=true"
import script from "./ManualTinderScanCreate.vue?vue&type=script&lang=js"
export * from "./ManualTinderScanCreate.vue?vue&type=script&lang=js"
import style0 from "./ManualTinderScanCreate.vue?vue&type=style&index=0&id=f2c25c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c25c4e",
  null
  
)

export default component.exports